import type { TopFrame_StartupParams } from '@ds/swymkit/typings'

import { compassFetch } from '~/services/fetch-compass'

interface FileDataResponse {
  fcsUrl: string
  fcsJobTicket: string
  code?: string
  status: number | string
  message?: string
  error?: {
    type: string
  } | string
}

/**
 *
 * @param data - response data comes from api
 * @returns - boolean value whether data is valid or not
 * @description - this function will check whether the response is valid or not and in case of error it will throw error
 */
// eslint-disable-next-line complexity
function isResultValid(data: FileDataResponse | string) {
  let isValid = false
  let error = ''

  if (typeof data === 'string')
    throw new Error(data)

  if (data) {
    if ((data.code && data.code !== '0') || data.error || (data.status && data.status !== 200)) {
      if (data.message && data.message !== '')
        error = data.message

      else if (data.error && typeof data.error !== 'string' && data.error.type)
        error = data.error.type

      else if (data.error)
        error = data.error as string

      else if (data.status)
        error = data.status as string

      throw new Error(error)
    }
    else {
      isValid = true
    }
  }

  return isValid
}

/**
 *
 * @param tenantID - tenantId
 * @returns response which will be used to show legal information
 * @description - this function is used to fetch startup info details
 */
export async function getStartupInfo(tenantID: string) {
  const redirectUrl = `/resources/AppsMngt/user/startup?platform=${tenantID}`
  return compassFetch.get(redirectUrl)
    .json<TopFrame_StartupParams>()
    .then(response => response)
}

/**
 *
 * @param url - compassUrl
 * @param language - language , ex- "en"
 * @param params - url parameters for api
 * @returns - file data which will be used to download the file
 * @description - this function will returns file data which is further used to download the file
 */
export async function fetchFileData(url: string, language: string, params: Record<string, string>) {
  const header = {
    'Accept': 'application/json',
    'Accept-Language': language,
  }
  const urlParams = new URLSearchParams(params)
  let urlParameters = urlParams.toString()
  urlParameters = (urlParameters.length > 0) ? `?${urlParams}` : ''
  const response = await compassFetch.get(`${url}/resources/AppsMngt/environment/checkoutticket${urlParameters}`, {
    timeout: 15000,
    headers: header,
    cache: 'no-cache',
  })
    .json<FileDataResponse>()

  if (isResultValid(response))
    return response
  throw new Error('Not Valid')
}
